export default {
  ENTER: "Enter"
};
